import InquiryListWrapper from "./InquiryListWrapper";
import InquiryCreate from "./pages/InquiryCreate";
import InquiryEdit from "./pages/InquiryEdit";
import InquiryView from "./pages/InquiryView";
import InquiryRecycleBin from "./pages/InquiryRecycleBin";
import VerticalGuard from "../../../components/common/VerticalGuard";

const inquiryRoutes = [
  {
    path: "/:vertical/inquiries",
    element: (
      <VerticalGuard>
        <InquiryListWrapper />
      </VerticalGuard>
    ),
  },
  {
    path: "/inquiries/recycle-bin",
    element: <InquiryRecycleBin />,
  },
  {
    path: "/:vertical/inquiries/create",
    element: (
      <VerticalGuard>
        <InquiryCreate />
      </VerticalGuard>
    ),
  },
  {
    path: "/:vertical/inquiries/:id/edit",
    element: (
      <VerticalGuard>
        <InquiryEdit />
      </VerticalGuard>
    ),
  },
  {
    path: "/:vertical/inquiries/:id/view",
    element: (
      <VerticalGuard>
        <InquiryView />
      </VerticalGuard>
    ),
  },
];

export default inquiryRoutes;
